var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorrectCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "correct 1",
    clipPath: "url(#clip0_1773_8742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 0C13.0047 0 0 13.0047 0 29C0 44.9953 13.0047 58 29 58C44.9953 58 58 44.9953 58 29C58 13.0047 44.9953 0 29 0Z",
    fill: "#00D37A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0244 19.2237C43.7267 19.9261 43.7267 21.0815 43.0244 21.7839L26.0322 38.7761C25.681 39.1272 25.2165 39.3085 24.7521 39.3085C24.2876 39.3085 23.8232 39.1272 23.472 38.7761L14.9759 30.28C14.2736 29.5776 14.2736 28.4222 14.9759 27.7198C15.6783 27.0175 16.8337 27.0175 17.5361 27.7198L24.7521 34.9358L40.4642 19.2237C41.1665 18.5101 42.322 18.5101 43.0244 19.2237Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1773_8742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectCircle);
export default __webpack_public_path__ + "static/media/correct-circle.2ce77a4990ef22dcf420879b66cd1e72.svg";
export { ForwardRef as ReactComponent };